import React, { useEffect, useState } from 'react';
import { Alert, Container, Spinner } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import useSettingsMountEffect from 'hooks/common/useSettingsMountEffect';
import { AgreementVersion } from 'models/Agreement';
import { getAgreement } from 'services/billingService';

const ServiceAgreementPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const requestedVersion = searchParams.get('version') || undefined;
  const [agreement, setAgreement] = useState<AgreementVersion | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useSettingsMountEffect({
    disableNavigationType: true,
    disableHorizontalNavbarAppearance: true,
    disableVerticalNavbarAppearance: true,
    disableHorizontalNavbarShape: true
  });

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    void getAgreement('service_agreement', requestedVersion)
      .then(data => {
        if (!cancelled) {
          setAgreement(data);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(
            err instanceof Error ? err.message : 'Failed to load agreement'
          );
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [requestedVersion]);

  useEffect(() => {
    document.title = agreement
      ? `Shiplab Service Agreement ${agreement.version}`
      : 'Shiplab Service Agreement';
  }, [agreement]);

  return (
    <div className="agreement-page bg-body">
      <Container className="py-6">
        {loading && (
          <div className="d-flex align-items-center gap-2 text-700 py-6">
            <Spinner animation="border" size="sm" />
            <span>Loading agreement…</span>
          </div>
        )}

        {error && (
          <Alert variant="danger" className="mt-4">
            {error}
          </Alert>
        )}

        {!loading && !error && agreement && (
          <div
            className="agreement-content"
            dangerouslySetInnerHTML={{ __html: agreement.content_html }}
          />
        )}
      </Container>
    </div>
  );
};

export default ServiceAgreementPage;
